import React, { useEffect, useState } from "react";
import { DatePicker, DatePickerInput, Button, Stack, Select, SelectItem, Tabs, Tab, TabList, TabPanels, TabPanel, FileUploaderDropContainer, ButtonSkeleton, Dropdown, DropdownSkeleton, Search, SearchSkeleton, DataTableSkeleton } from "@carbon/react";
import { CardComponent, CardRow } from '../../../components/Layouts/Card.styles'
import Card from '../../../components/Layouts/Card';
import { Calendar } from "@carbon/icons-react";
import { useDispatch, useSelector, batch } from 'react-redux'
import Typography from "../../../components/Basics/Typography";
import InformationContainer from '../../../components/Basics/Information.container';
import TrimbleCarbonTable from "./TrimbleDataTable.container";
import * as XLSX from 'xlsx';
import { onUploadExcelTrimbleThunk, fetchFoldersThunk, fetchSubFoldersThunk, onGetTrimbleDataThunk } from "./Trimble.actions";
import TrimbleDataTable from "./DataTable.container";

const TrimbleContainer = () => {
  const dispatch = useDispatch()
  const { error, loading, data, folders, loadingFolder, errorFolder, loadingSubFolder, errorSubFolder, subFolders, loadingTrimbleData, errorTrimbleData, trimbleData } = useSelector(state => state.trimble)
  const [fileUploaded, setFileUploaded] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [file, setFile] = useState(null);
  const [fileError, setError] = useState('');
  const [selectedFolder, setSelectedFolder] = useState('');
  const [filters, setFilters] = useState({
    machine: "Desconocido",
    area: "No especificado",
    dateRange: "No disponible",
    sectionInterval: "No disponible",
    ejeLeftRight: "No disponible"
  });
  

  useEffect(() => {
    dispatch(fetchFoldersThunk(''));
  }, []);

  const handleFolderSelect = (event) => {
    const selectedPath = event?.selectedItem;
    dispatch(fetchSubFoldersThunk(selectedPath));
  };

  const [loadingTable, setLoadingTable] = useState(true); // Track loading state for the table
  const headersFolders = [
    { key: 'id', header: 'ID' },
    { key: 'alineacion_partition', header: 'Alineación Partición' },
    { key: 'date_partition', header: 'Fecha Partición' },
    { key: 'Nombre Máquina', header: 'Nombre Máquina' },
    { key: 'Área_Personalizada', header: 'Área Personalizada' },
    { key: 'Intervalo Sección Transversal', header: 'Intervalo Sección Transversal' },
    { key: 'D.eje_Izquierda_Derecha', header: 'D. Eje Izquierda/Derecha' },
  ];  

  const headersTrimbleData = [
    { key: 'nombre_maquina', header: 'Nombre Máquina' },
    { key: 'area_personalizada', header: 'Área Personalizada' },
    { key: 'estacion__m_', header: 'Estación (m)' },
    { key: 'min_elevacion__m_', header: 'Min Elevación (m)' },
    { key: 'max_elevacion__m_', header: 'Max Elevación (m)' },
    { key: 'prom_elevacion__m_', header: 'Prom Elevación (m)' },
    { key: 'min_cuenta_de_pasadas', header: 'Min Cuenta de Pasadas' },
    { key: 'max_cuenta_de_pasadas', header: 'Max Cuenta de Pasadas' },
    { key: 'prom_cuenta_de_pasadas', header: 'Prom Cuenta de Pasadas' },
    { key: 'filtro_fecha', header: 'Filtro Fecha' },
    { key: 'intervalo_seccion_transversal', header: 'Intervalo Sección Transversal' },
    { key: 'd_eje_izquierda_derecha', header: 'D. Eje Izquierda/Derecha' },
    { key: 'limite_diseno', header: 'Límite Diseño' },
    { key: 'alineacion', header: 'Alineación' }
  ];
  
  const fetchData = (alineation, date) => {
    console.log("Alineación:", alineation);
    console.log("Fecha Partición:", date);
    return dispatch(onGetTrimbleDataThunk(alineation, date))
  };

  const handleUploadFile = () => {
    if (!file || !file.file) return; // Ensure there's a valid file to upload
    dispatch(onUploadExcelTrimbleThunk(file.file));
    dispatch(fetchFoldersThunk(''));
  };  

  const readExcelFile = async (uploadedFile) => {
    setFileUploaded(true);
    setLoadingTable(true);

    const reader = new FileReader();

    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: 'array', cellStyles: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

      // Extract Filter Information
      let machineRow = jsonData[10]?.[0] || "";
      let areaRow = jsonData[11]?.[0] || "";
      let dateRangeRow = jsonData[9]?.[0] || "";

      let machineName = machineRow.includes(":") ? machineRow.split(": ")[1] : "Desconocido";
      let area = areaRow.includes(":") ? areaRow.split(": ")[1] : "No especificado";
      let dateRange = dateRangeRow.includes(":") ? dateRangeRow.split(": ")[1] : "No disponible";

      // Locate the actual headers row dynamically
      let headerRowIndex = jsonData.findIndex((row) =>
        row.includes("Estación (m)")
      );

      if (headerRowIndex === -1) {
        console.error("Could not find header row in Excel file.");
        setLoadingTable(false);
        return;
      }

      let parsedData = [];
      let stationValues = [];

      // Locate "D.eje" Row and Extract the Next Row Below It
      let ejeRowIndex = jsonData.findIndex(row => row.includes("D.eje"));
      let ejeValues = "No disponible";

      if (ejeRowIndex !== -1 && ejeRowIndex + 1 < jsonData.length) {
        let ejeDataRow = jsonData[ejeRowIndex + 1]; // The row below the D.eje headers

        ejeValues = ejeDataRow
          .slice(1) // Remove first column (station number)
          .filter(value => value !== undefined && value !== 0) // Remove empty values and central axis (0)
          .map(value => `${value}m`) // Format values
          .join(", ");
      }

      // Iterate through all station rows dynamically
      for (let i = headerRowIndex + 1; i < jsonData.length; i++) {
        const row = jsonData[i];

        const stationValue = row[0] ? String(row[0]) : '';

        if (!stationValue || isNaN(parseInt(stationValue.replace(',', ''), 10))) {
          continue;
        }

        let station = parseInt(stationValue.replace(',', ''), 10);
        stationValues.push(station);

        let elevationRowIndex = jsonData.findIndex((r, index) =>
          index > i && r.includes("Elevación (m)")
        );

        let countRowIndex = jsonData.findIndex((r, index) =>
          index > i && r.includes("Cuenta de Pasadas")
        );

        let elevacionRow = elevationRowIndex !== -1 ? jsonData[elevationRowIndex] : [];
        let cuentaPasadasRow = countRowIndex !== -1 ? jsonData[countRowIndex] : [];

        parsedData.push({
          id: `row-${i}`,
          machine: machineName,
          area: area,
          station,
          elev_min: elevacionRow[9] ? parseFloat(elevacionRow[9].toString().replace(',', '.')) : '',
          elev_max: elevacionRow[10] ? parseFloat(elevacionRow[10].toString().replace(',', '.')) : '',
          elev_prom: elevacionRow[11] ? parseFloat(elevacionRow[11].toString().replace(',', '.')) : '',
          pasadas_min: cuentaPasadasRow[9] ? parseInt(cuentaPasadasRow[9]) : '',
          pasadas_max: cuentaPasadasRow[10] ? parseInt(cuentaPasadasRow[10]) : '',
          pasadas_prom: cuentaPasadasRow[11] ? parseInt(cuentaPasadasRow[11]) : ''
        });

        i = Math.max(elevationRowIndex, countRowIndex);
      }

      // Compute the most common step size
      let stepSizes = stationValues
        .sort((a, b) => a - b)
        .map((value, index, array) => (index > 0 ? value - array[index - 1] : null))
        .filter(diff => diff !== null);

      let sectionInterval = stepSizes.length > 0 ? mostCommonValue(stepSizes) : 10;

      setFilters({ machine: machineName, area, dateRange, sectionInterval, ejeLeftRight: ejeValues });

      setTableData(parsedData);
      setLoadingTable(false);
    };

    reader.readAsArrayBuffer(uploadedFile);
  };

  // Helper function to find the most common interval
  const mostCommonValue = (arr) => {
    let counts = {};
    arr.forEach(num => counts[num] = (counts[num] || 0) + 1);
    return parseInt(Object.keys(counts).reduce((a, b) => (counts[a] > counts[b] ? a : b), 0));
  };


  const handleAddFile = (evt, { addedFiles }) => {
    if (addedFiles.length > 0) {
      const newFile = addedFiles[0];

      // Check if the file type is .xlsx
      if (newFile.type !== 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
        setError('Invalid file type. Please upload an .xlsx file.');
        return;
      }

      setFile({
        uuid: newFile.name,
        name: newFile.name,
        status: 'edit',
        file: newFile,
      });
      setError('');
      readExcelFile(newFile);  // Read the Excel file
    }
  };

  const handleDeleteFile = () => {
    setFile(null);
    setError('');
    setTableData([]); // Clear table data when file is deleted
    setFilters({
      machine: "Desconocido",
      area: "No especificado",
      dateRange: "No disponible",
      sectionInterval: "No disponible",
      ejeLeftRight: "No disponible"
    })
  };

  return (
    <>
      <Stack gap={3}>
        <p className="cds--file--label">Subir informe Estación y D.Eje</p>
        <p className="cds--label-description">El archivo subido mostrara un versión resumida de las pasadas del reporte separadas por sus intervalos de sección transversal.</p>

        {fileError && <p style={{ color: 'red' }}>{fileError}</p>}

        <div style={{ display: 'inline-block' }}>
          {!file ? (
            <FileUploaderDropContainer
              accept={['.xlsx']}
              labelText="Arrastre y suelte el archivo para cargar en la plataforma"
              name=""
              onAddFiles={handleAddFile}
            />
          ) : (
            <>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '10px', width: '100%' }}>
                <p>{file.name}</p>
                <Button style={{ width: '100%' }} onClick={handleDeleteFile} kind="secondary" size="lg">
                  Remover Archivo
                </Button>
                {loading ? (
                  <ButtonSkeleton />

                ) : (
                  <Button style={{ width: '100%' }} onClick={handleUploadFile} kind="primary" size="lg">Subir Archivo</Button>
                )}
              </div>
            </>
          )}
        </div>
        <CardComponent>
          <Card justifyContent='flex-start'>
            <Calendar size={18} />
            <Typography className='cds--type-heading-compact-01'>
              INFORMES SUBIDOS A LA PLATAFORMA
            </Typography>
          </Card>
          {loadingFolder ? (
            <>
              <DropdownSkeleton />
              <SearchSkeleton />
            </>
          ) : (
            <>
              <Dropdown style={{ width: '30%' }} size="lg" id="default" helperText='Si el informe que acaba de subir no aparece acá, necesita refrescar la vista.' titleText="Archivo de Alineamiento" label="Seleccione un archivo de alineamiento"
                items={folders} onChange={handleFolderSelect}
              />
            </>
          )}
        </CardComponent>
        <CardComponent>
          <Card>
            {loadingSubFolder? (
              <DataTableSkeleton />
            ) : (
              <TrimbleCarbonTable rows={subFolders} headers={headersFolders} fetchData={fetchData} />
            )}
          </Card>
        </CardComponent>
        <Card justifyContent='flex-start'>
            <Calendar size={18} />
            <Typography className='cds--type-heading-compact-01'>
              INFORMES
            </Typography>
          </Card>
        <CardComponent>
          <Card>
            {loadingTrimbleData ? (
              <DataTableSkeleton />
            ) : (
              <TrimbleDataTable rows={trimbleData} headers={headersTrimbleData} />
            )}
          </Card>
        </CardComponent>
      </Stack>
    </>
  )
};

export default TrimbleContainer;
